<template>
  <div class="seamless_scroll">
    <div class="ss_title">商品详情</div>
    <div class="ss_content">
      <div class="left">
        <div class="atr">基础属性</div>
        <div class="seamless-warp">
          <div class="attr_item" v-for="(item, i) in list1" :key="i">
            {{ item.key }}：{{ item.value }}
          </div>
        </div>
      </div>
      <div class="right">
        <div class="atr">特殊属性</div>
        <div class="seamless-warp">
          <div class="attr_item" v-for="(item, i) in list2" :key="i">
            <div class="name">{{ item.attributeName }}：</div>
            <div class="value">
              <div class="value_item" v-for="(it,index) in item.value.toString().split(',')" :key="index">
                {{ it }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "seamless-scroll",
  props: {
    list1: {
      type: Array,
      default: [],
    },
    list2: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {};
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.seamless_scroll {
  margin-bottom: 1rem;
  .ss_title {
    text-align: center;
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
    position: relative;
    &::before,
    &::after {
      content: "";
      position: absolute;
      width: 13.5rem;
      height: 1px;
      background-color: #ddd;
      top: 50%;
      transform: translateY(-50%);
    }
    &::before {
      left: 0;
    }
    &::after {
      right: 0;
    }
  }
  .ss_content {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 0 0;
    .left,
    .right {
      flex: 1;
      background-color: #fff;
      border-radius: 0.6rem;
      overflow: hidden;
      .atr {
        font-size: 1.4rem;
        text-align: center;
        background-color: var(--theme);
        height: 2.8rem;
        line-height: 2.8rem;
        color: #fff;
      }
      .seamless-warp {
        height: 12rem;
        overflow-y: auto;
        padding: 0.5rem 0.8rem;
        &::-webkit-scrollbar {
          width: 4px;
        }
        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
          opacity: 0.2;

        }
        &::-webkit-scrollbar-track {
          -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
          border-radius: 0;
        }
        .attr_item {
          margin-bottom: 0.5rem;
          color: #666;
          font-size: 1.2rem;
          display: flex;
          align-items: flex-start;
          .name {
            white-space: nowrap;
          }
          .value {
            margin-top: 0.2rem;
          }
          .value_item {
            word-break: break-all;
          }
        }
      }
    }
    .left {
      margin-right: 0.5rem;
    }
  }
}
</style>
